import api from '@/shared/api/client';

/**
 * Appels aux actions en masse (réservées à l'admin côté API).
 *
 * Toutes renvoient le même rapport : { total, ok, failed: [{ id, error }] }.
 * Un rapport avec `failed` non vide N'EST PAS une erreur HTTP — c'est un succès
 * partiel, normal dès qu'on parle à du matériel. L'appelant l'affiche via
 * <BulkResultDialog>.
 */

const post = (path, body) => api.post(path, body).then(r => r.data);

// --- Clients -----------------------------------------------------------------
export const bulkUpdateClients = (ids, patch, createdBy) =>
  post('/bulk/clients/update', { ids, patch, created_by: createdBy || null });

export const bulkDeleteClients = (ids) => post('/bulk/clients/delete', { ids });

// --- Actifs ------------------------------------------------------------------
export const bulkUpdateAssets = (ids, patch) => post('/bulk/assets/update', { ids, patch });

export const bulkDeleteAssets = (ids) => post('/bulk/assets/delete', { ids });

// --- Pilotage ----------------------------------------------------------------
/** action ∈ charge | decharge | stop | auto | power_zero */
export const bulkBatteryCommand = (ids, action, puissanceW) =>
  post('/bulk/pilotage/battery', { ids, action, puissance_w: puissanceW ?? null });

export const bulkTuyaRecheck = (ids) => post('/bulk/devices/tuya-recheck', { ids });

export const bulkTuyaUnlock = (ids) => post('/bulk/devices/tuya-unlock', { ids });

// --- Utilisateurs ------------------------------------------------------------
export const bulkUpdateUsers = (ids, role) => post('/bulk/users/update', { ids, role });

export const bulkDeleteUsers = (ids) => post('/bulk/users/delete', { ids });

export const bulkReinviteUsers = (ids) => post('/bulk/users/reinvite', { ids });

// --- Alertes -----------------------------------------------------------------
export const bulkMarkAlertsRead = (ids) => post('/bulk/alerts/read', { ids });

export const bulkMarkAlertsUnread = (ids) => post('/bulk/alerts/unread', { ids });

/**
 * Action de pilotage appliquée à N actifs, tous types confondus.
 *
 * Une sélection mixte est légitime : les actifs dont le type n'expose pas l'action
 * partent en échec avec leur raison, les autres passent. Le rapport porte en plus
 * `simules` — le nombre d'actifs pour lesquels aucune intégration n'est branchée.
 */
export const bulkAssetAction = (ids, action, value = null) =>
  post('/bulk/pilotage/action', { ids, action, value });
